import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { LanguageProvider } from "./i18n";
import "./index.css";

// StrictMode is kept on deliberately, matching the previous Next config
// (reactStrictMode: true). It double-invokes effects in development to surface
// effects that don't clean up properly -- MapPreview specifically depends on
// surviving that, and its deferred-teardown logic exists because of it. Turning
// StrictMode off here would hide that class of bug rather than fix it.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>
);
